export default "__VITE_ASSET__BXqV$IRw__"